import React, { useId, useRef, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import '../../assets/styles/Accordion.css';

const NAV_KEYS = ['ArrowDown', 'ArrowUp', 'Home', 'End'];

const Accordion = ({
  items = [],
  defaultValue = null,
  collapsible = true,
  headingLevel = 3,
  className = '',
  ...props
}) => {
  const [openId, setOpenId] = useState(defaultValue);
  const baseId = useId();
  const rootRef = useRef(null);
  const Heading = `h${headingLevel}`;

  const toggle = (id) =>
    setOpenId((current) => {
      if (current !== id) return id;
      return collapsible ? null : current;
    });

  const handleKeyDown = (event) => {
    if (!NAV_KEYS.includes(event.key)) return;
    const triggers = [...rootRef.current.querySelectorAll('.tp-accordion__trigger')];
    const index = triggers.indexOf(document.activeElement);
    if (index === -1) return;
    event.preventDefault();
    const last = triggers.length - 1;
    const next = {
      ArrowDown: index === last ? 0 : index + 1,
      ArrowUp: index === 0 ? last : index - 1,
      Home: 0,
      End: last
    }[event.key];
    triggers[next].focus();
  };

  return (
    <div
      ref={rootRef}
      className={`tp-accordion ${className}`.trim()}
      onKeyDown={handleKeyDown}
      {...props}
    >
      {items.map((item) => {
        const open = openId === item.id;
        const triggerId = `${baseId}-${item.id}-trigger`;
        const panelId = `${baseId}-${item.id}-panel`;
        return (
          <div key={item.id} className={`tp-accordion__item ${open ? 'is-open' : ''}`.trim()}>
            <Heading className="tp-accordion__heading">
              <button
                type="button"
                id={triggerId}
                className="tp-accordion__trigger"
                aria-expanded={open}
                aria-controls={panelId}
                onClick={() => toggle(item.id)}
              >
                <span>{item.title}</span>
                <ChevronDown className="tp-accordion__chevron" size={16} strokeWidth={2} aria-hidden="true" />
              </button>
            </Heading>
            <div
              id={panelId}
              role="region"
              aria-labelledby={triggerId}
              className="tp-accordion__panel"
            >
              <div className="tp-accordion__panel-inner">
                <div className="tp-accordion__content">{item.content}</div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Accordion;
export { Accordion };
